var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({class:_vm.bolder ? 'body-semibold' : 'body-medium',staticStyle:{"border-radius":"18px","align-content":"center","cursor":"pointer"}},'div',{ ..._vm.$attrs },false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }